import React, { useEffect, useState } from 'react'

import './Preloader.scss'

const LABEL_PREFIX = '加载'

export const Preloader = () => {
  const [label, setLabel] = useState(LABEL_PREFIX)

  useEffect(() => {
    const interval = setInterval(() => {
      setLabel(l => {
        let str = `${ l }.`
        if (str === `${ LABEL_PREFIX }....`) str = LABEL_PREFIX

        return str
      })
    }, 750)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="preloader">
      <span>
        { label }
      </span>
    </div>
  )
}